import { mixGetV1 } from "../../services/mixin";

export interface CareStatusItem {
    id: number;
    name: string;
    code: string;
    type: string;
    position: number;
    description: string;
    color: string;
    is_active: number;
}

export interface CareStatusResponse {
    status: boolean;
    data: {
        total: number;
        current_page: number;
        items: CareStatusItem[];
    };
}

let careStatusCache: CareStatusItem[] | null = null;
let careStatusPromise: Promise<CareStatusItem[]> | null = null;

export const fetchCareStatuses = async (): Promise<CareStatusItem[]> => {
    if (careStatusCache) {
        return careStatusCache;
    }
    if (!careStatusPromise) {
        careStatusPromise = (async () => {
            try {
                const res: CareStatusResponse = await mixGetV1("/api/v1/be/customer-care-statuses", {
                    limit: 100,
                    sort: ["id,desc"],
                });
                if (res.status && res.data?.items) {
                    careStatusCache = res.data.items;
                    return res.data.items;
                }
                return [];
            } catch {
                return [];
            } finally {
                careStatusPromise = null;
            }
        })();
    }
    return careStatusPromise;
};

export const mapCareStatusToLabel = (item: CareStatusItem) => ({
    key: String(item.id),
    label: item.name,
    color: item.color,
    id: item.id,
});